import { useEffect, useState } from "react"
import "./css/MailboxLinked.css"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { useNavigate } from "react-router-dom"

const MailboxLinked = () => {
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    const params = new URLSearchParams(window.location.search)
    const code = params.get("code")

    const _crm__token = localStorage.getItem("_crm__token")

    const verifyCode = async () => {
        setLoading(true)
        const host = window.location.host
        const protocol = window.location.protocol

        const { data, status } = await axios.post(`${api}/Sessions/oauth/google`, {
            token: _crm__token,
            redirect: `${protocol}//${host}/crm/mailbox/oauth`,
            code
        })

        if (data.success) {
            localStorage.setItem("mailbox-link", 1)
            navigate("/mailbox")
        }

        setLoading(false)
    }

    useEffect(() => {
        verifyCode()
    }, [])

    return (
        <div className="_1qiw">
            {loading ? <div className="soled-butt">
                <SpinnerCircular size="80" color="rgb(141, 95, 185)" />
            </div> : undefined}
        </div>
    )
}

export default MailboxLinked
